import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 1rem;
  box-sizing: border-box;
  
  @media (max-width: 575.98px) {
    padding: 0.75rem;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 2.5rem 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 420px;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 575.98px) {
    padding: 1.5rem 1.25rem;
    border-radius: 10px;
    max-width: 100%;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1rem 0;
  
  @media (max-width: 575.98px) {
    margin: 0.75rem 0;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  margin-bottom: 20em !important;
`;

export const ErrorText = styled.span`
  color: #dc3545;
  font-size: 0.875rem;
  margin: 0 0 1rem 0;
  display: block;
  text-align: center;
  
  @media (max-width: 575.98px) {
    font-size: 0.8rem;
    margin: 0 0 0.75rem 0;
  }
`;
